import { useContext } from 'react';
import {Box, Flex} from '../shared/layouts';
import {useTranslation} from 'react-i18next';
import styled from '@emotion/styled';
import Button from '../shared/Button';
import {useTheme} from '@emotion/react';
import {useMediaQuery} from '@dnhb/node_package';
import UserContext from "../../context/UserContext";
import axios from "axios";

const LanguageFlex = styled(Flex)({
  position: 'fixed',
  maxHeight: '70px',
  zIndex: 99,
  fontWeight: 'bold',
  color: 'secondary',
  borderRadius: '3em',
  padding: '0.5em',
  boxShadow: '0px 0px 8px 0px #00000020',
});


const LanguageModule = ({setIsLoading}) => {
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.desktop ?? '37.5rem'})`
  );
  const { i18n } = useTranslation();
  const { user, setUser } = useContext(UserContext);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    if (user?.language) {
      setIsLoading(true);
      axios.put(
        '/user/settings/language/change',
        { language : lang },
        {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }
      ).then(() => {
        setUser(user => ({ ...user, language: lang }));
        window.location.reload();
      }).catch(() => setIsLoading(false));
    }
  }

  if (user) return null;
  if (window.location.href.includes('sign-request-signed')) return <></>;

  return (
    <LanguageFlex
      flexDirection={{'mobile': 'column', 'desktop': 'row' }}
      justifyContent={{'mobile': 'center', 'desktop': 'flex-end' }}
      alignItems="center"
      css={({ colors }) => ({
        top: isMinDesktop ? '1rem' : '0',
        right: isMinDesktop ? '1rem' : '4px',
        backgroundColor: colors?.white,
        height: 'auto'
      })}
    >
      <Button
        buttonSize="tiny"
        variant="anchor"
        title="Nederlands"
        onClick={() => handleLanguageChange('nl')}
        css={i18n.language === 'nl' ? { fontWeight: '800' } : { textDecoration: 'underline' }}
      >
        NL
      </Button>
      <Box color="secondary" css={{ lineHeight: '1rem', flex: '4px 0 0', transform: !isMinDesktop ? 'rotate(90deg)' : null }}>|</Box>
      <Button
        buttonSize="tiny"
        variant="anchor"
        title="English"
        onClick={() => handleLanguageChange('en')}
        css={i18n.language === 'en' ? { fontWeight: '800' } : { textDecoration: 'underline' }}
      >
        EN
      </Button>
    </LanguageFlex>
  );
};

export default LanguageModule;
